import {
    apiRequest,
    excludeAbsenDetail,
    excludeAbsenUpdate,
    employeeList
} from "../../../../../services/adapters/kepegawaian/excludeAbsenService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", excludeAbsenDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", excludeAbsenUpdate, {
            body: query
        }, true)
    }

    fetchEmployee = async (query) => {
        return await apiRequest("get", employeeList, {
            params: query
        }, true)
    }
}

export default UpdateRepository